import { AxiosResponse, HttpStatusCode } from "axios";

import { errors } from "../../constants";
import { SESSION_ENDED_TRANSLATION_KEYS } from "../../constants/auth.constants";
import { ForbiddenReason } from "../../enums";
import { ApiException, IApiError } from "../../models";
import { normalizeApiError } from "./api-utils";

export const handleForbiddenResponseException = (
  failedResponse: AxiosResponse,
): never => {
  const data = failedResponse.data as IApiError | undefined;
  const sessionEndedKey = data?.translationKey;

  if (sessionEndedKey && SESSION_ENDED_TRANSLATION_KEYS.has(sessionEndedKey)) {
    throw new ApiException(
      normalizeApiError({
        apiError: data,
        fallbackTranslationKey: errors.common.forbiddenResponseStatus,
      }),
      HttpStatusCode.Forbidden,
    );
  }

  throw new ApiException(
    normalizeApiError({
      apiError: data,
      fallbackTranslationKey:
        data?.message === ForbiddenReason.ResponseByPermission
          ? errors.common.forbiddenResponseByPermission
          : errors.common.forbiddenResponseStatus,
    }),
    HttpStatusCode.Forbidden,
  );
};
